import React from "react";
import HomeLoanOffer from "./LoanOffer/HomeLoanOffer";
import PersonalLoanOffer from "./LoanOffer/PersonalLoanOffer";
import BusinessLoanOffer from "./LoanOffer/BusinessLoanOffer";
import MortgageLoanOffer from "./LoanOffer/MortgageLoanOffer";
import NriLoanOffer from "./LoanOffer/NriLoanOffer";
import DoctorLoanOffer from "./LoanOffer/DoctorLoanOffer";


const OurServices = () => {
  return (
    <div className="ourservice-container">
      <div className="ourservice-content">
        <div className="ourservice-reject-content">
          <p>
            <span className="highlight-rate">Most rejections aren’t the bank’s fault — they’re caused by
            mismatched applications</span>. At Right Lender, our digital technology
            analyzes your profile and matches you with the right bank or NBFC
            from 65+ partners before your application is moved to the lender.
            This ensures higher approval chances, no wasted applications, and a
            faster, stress-free borrowing experience.
          </p>
        </div>
        <div className="ourservice-header">
          <p className="ourservice-subtitle">Products</p>
        </div>
        <div className="ourservice-select-type">
          <h4 className="highlight-rate highlight-color">Select your Loan</h4>
          <h5 className="ourservice-select-title">
            Fill the Application → Complete VKYC & eNACH → Get Disbursed by the
            Right Bank/NBFC
          </h5>

          <div className="special-service-inline">
            <span>100% Digital Process</span>
            <span>Real-Time Offers</span>
            <span>Exclusive Rewards</span>
            <span>End-to-End Support</span>
          </div>
        </div>

        <div className="ourservice-body-sections">
          <div className="ourservice-section ourservice-right-section">
            <PersonalLoanOffer />
          </div>
          <div className="ourservice-section ourservice-middle-section">
            <BusinessLoanOffer />
          </div>
          <div className="ourservice-section ourservice-left-section">
            <DoctorLoanOffer />
          </div>
          <div className="ourservice-section ourservice-right-section">
            <NriLoanOffer />
          </div>
          <div className="ourservice-section ourservice-middle-section">
            <HomeLoanOffer />
          </div>
          <div className="ourservice-section ourservice-left-section">
            <MortgageLoanOffer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurServices;

        